import { createSlice } from '@reduxjs/toolkit';
import { buildAsyncReducers } from '../thunkTemplate';
import { orgs as initialState } from '../initialState';

import { getOrgs, createOrg, addOrgAppMapping } from './_orgs';

const { reducer } = createSlice({
  name: 'orgs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [getOrgs, createOrg, addOrgAppMapping]);
  },
});

export { getOrgs, createOrg, addOrgAppMapping };
export default reducer;
